import React from "react";

class HeaderRow extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      name,
      sortable,
      field,
      sortField,
      type,
      setSort,
      meta
    } = this.props;

    let c, onClick = null, cs = "";

    if (sortable && meta.get("sortField") === (sortField || field)) {
      c = (
        <i
          className={
            "fa fa-sort-" + type + "-" + meta.get("sortDir") + " fa-fw"
          }
        />
      );
    } else {
      c = <i className="grayed fa fa-sort fa-fw" />;
    }

    if (sortable) {
      cs = "sortable";
      onClick = setSort.bind(
        this,
        sortField || field,
        meta.get("sortDir") === "desc" ? "asc" : "desc"
      );
    }

    return (
      <th className={cs} onClick={onClick}>
        {name} {c}
      </th>
    );
  }
}

export default HeaderRow;



// WEBPACK FOOTER //
// ./src/browser/components/Table/HeaderRow.js